import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "../../app/utils"
import { BulkPatchFeatureWeightsDto } from "@dialogics/shared/dto/types"
import { Feature, ClientType, FeatureWeight2 } from "@prisma/client"

export type FeatureWeight2WithRelations = FeatureWeight2 & {
  feature: Feature
  client_type: ClientType
}

export const featureWeightApi = createApi({
  reducerPath: "featureWeightApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/feature-weights" }),
  tagTypes: ["FeatureWeight"],
  endpoints: builder => ({
    getWeightsByOrganizationGroup: builder.query<FeatureWeight2WithRelations[], { organizationGroupId: number }>({
      query: params => ({ url: "", params }),
      providesTags: [{ type: "FeatureWeight", id: "LIST" }],
    }),
    bulkPatchWeights: builder.mutation<void, BulkPatchFeatureWeightsDto>({
      query: body => ({ url: "/bulk", method: "PATCH", body }),
      invalidatesTags: [{ type: "FeatureWeight", id: "LIST" }],
    }),
  }),
})

export const { useGetWeightsByOrganizationGroupQuery, useBulkPatchWeightsMutation } = featureWeightApi

